const AVATAR_BACKGROUNDS = [
  'linear-gradient(135deg, #7c9cff 0%, #4f7cff 100%)',
  'linear-gradient(135deg, #72d6c9 0%, #4cb6a8 100%)',
  'linear-gradient(135deg, #c586ff 0%, #8b5cf6 100%)',
  'linear-gradient(135deg, #ffcb66 0%, #f59e0b 100%)',
  'linear-gradient(135deg, #ff9b8e 0%, #ef4444 100%)',
  'linear-gradient(135deg, #8ad19a 0%, #22a55a 100%)',
  'linear-gradient(135deg, #f9a8d4 0%, #ec4899 100%)',
  'linear-gradient(135deg, #ffb36b 0%, #f97316 100%)',
] as const

export function avatarBackgroundFor(value: string | null | undefined): string {
  const normalizedValue = value?.trim()
  if (!normalizedValue) return AVATAR_BACKGROUNDS[0]

  const index =
    Array.from(normalizedValue).reduce(
      (sum, char) => sum + char.charCodeAt(0),
      0
    ) % AVATAR_BACKGROUNDS.length

  return AVATAR_BACKGROUNDS[index]
}
